import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import PermissionCheckAddCommentQuery, {
	type PermissionCheckAddCommentQuery$data,
	type PermissionCheckAddCommentQuery$variables,
} from './__generated__/PermissionCheckAddCommentQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadAddCommentPermissionCheck(
	contentId: string,
	status: PermissionCheckAddCommentQuery$variables['status'] = ['draft', 'current'],
): Promise<{
	data: PermissionCheckAddCommentQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<PermissionCheckAddCommentQuery$data, PermissionCheckAddCommentQuery$variables>({
		query: PermissionCheckAddCommentQuery,
		variables: {
			contentId,
			status,
		},
	});
}
